import { PageBodyComponents } from '@my-types';
import { React, Styled } from '@common/3rd';
import Widget from '../widget';

/**
 * Page body
 */
class PageBody<P, S, C extends PageBodyComponents> extends Widget<P, S, C> {
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'page-body'
			})`
				flex-grow: 1;
			`
		} as C;
	}
	render() {
		const C = this.getComponents();
		return <C.Box>{this.props.children}</C.Box>;
	}
}

export default PageBody;
